import React from 'react';
import { cn } from '../../utils/cn';

const AuthBrandingPanel = ({
  children,
  className = '',
  widthClass = 'lg:w-1/2',
  imageClassName = 'w-84',
}) => {
  return (
    <div
      className={cn(
        'hidden lg:flex items-center justify-center bg-black text-primary-foreground p-12',
        widthClass,
        className,
      )}
    >
      <div className="w-full max-w-md flex flex-col items-start text-left space-y-8">
        <img
          src="/assets/images/logo-with-text-white-on-black.png"
          alt="Ougama"
          className={cn('max-w-full h-auto', imageClassName)}
        />
        {children}
      </div>
    </div>
  );
};

export default AuthBrandingPanel;
